module.exports = __webpack_public_path__ + "static/team3-d9bd4fe6aa3269ee739ef6cb024f5884.png";